import { render, staticRenderFns } from "./FaceInstructions.vue?vue&type=template&id=eb3ad608"
import script from "./FaceInstructions.vue?vue&type=script&lang=js"
export * from "./FaceInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports